import { LiveStreamErrorType, LiveStreamOperatorType } from 'eTip--common';
import { useState } from 'react';
import React from 'react';
import { translation } from 'easit--localization';

interface IMatchTrackerPlayerProps {
    externalId: string;
    operator: LiveStreamOperatorType;
    eventName: string
    elementId: string;
    languageId: string;
    canFixHeightOnLoad: boolean; //for mobile

    matchTrackerKey: string;

    shownForMonitoring: () => void;
    stoppedForMonitoring: () => void;
    errorLoadingContent: (errorType: LiveStreamErrorType) => void;
}

export const MatchTrackerPlayer: React.FC<IMatchTrackerPlayerProps> = (props: IMatchTrackerPlayerProps) => {
    const [stateExternalId, stateSetExternalId] = useState<string>(null); //expecting that externalId is mutual for Normal and Staging type
    const [stateWidgetExists, stateSetWidgetExists] = useState<boolean>(false);
    const [stateInitTimer, stateSetInitTimer] = useState<number>(0);
    const timerRef = React.useRef(stateInitTimer);
    let wrapperRef = React.useRef<HTMLDivElement>();
    const [stateWrapperMinHeight, setStateWrapperMinWidth] = useState<number>(-1);

    const elementIdentifier = "#" + props.elementId;

    React.useEffect(() => {
        if (stateExternalId !== props.externalId) {
            stateSetExternalId(props.externalId);
            run();
        }
        return () => { destroy(false); };
    }, [props.externalId]); //!! release

    React.useEffect(() => { //final destroy, desktop use this
        return () => { destroy(true); };
    }, []);

    const destroy = (isFull: boolean): void => { //called after every change of matchId
        if (isFull) {
            if (window["SIR"]) {
                window['SIR']("removeWidget", elementIdentifier);
            }
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
                stateSetInitTimer(0);
            }
        }
        if (props.canFixHeightOnLoad) {
            window.removeEventListener("resize", onResize);
        }

        props.stoppedForMonitoring();
    }

    const streamInitialized: () => boolean = () => {
        return props.operator === LiveStreamOperatorType.MatchTrackerBRStage ? $(elementIdentifier + " .sr-lmt-plus-f1").length > 0 : $(elementIdentifier + " .sr-lmt-plus").length > 0;
    }

    const run: () => void = () => {

        //see https://widgets.sir.sportradar.com/docs/store/SIR.html
        if (!window['SIR']) {
            (function (a, b, c, d, e, f, g?: any, h?: any, i?: any) {
                a[e] || (i = a[e] = function () { (a[e].q = a[e].q || []).push(arguments) }, i.l = 1 * new Date().getTime(), i.o = f,
                    g = b.createElement(c), h = b.getElementsByTagName(c)[0], g.async = 1, g.src = d, g.setAttribute("n", e), h.parentNode.insertBefore(g, h)
                )
            })(window, document, "script", `https://widgets.sir.sportradar.com/${props.matchTrackerKey}/widgetloader`, "SIR", {
                theme: false, // using custom theme
                language: props.languageId,
            });

            if (stateInitTimer > 0) {
                window.clearTimeout(timerRef.current);
            }
            timerRef.current = window.setTimeout(() => {
                if (!streamInitialized()) {
                    window['SIR'] = null;
                    props.errorLoadingContent(LiveStreamErrorType.InitPlayer);
                }
            }, 15000);
            stateSetInitTimer(timerRef.current);
        }

        let params: any = {
            showOdds: false,
            disablePitchNoise: true,
            disablePitchStripes: true,
            disablePitchOverlay: true,
            disablePitchSpotlights: true,
            adsFrequency: false,
            momentum: "compact" /* or extended */,
            pitchLogo: __IsMTS__ && !__IsMTSTipos__ ? "/content/v3/styles/css/matchtracker/source/Synot-logo.png" : "/content/styles/css/matchtracker/source/pitch-logo-23.png",
            goalBannerImage: __IsMTS__ && !__IsMTSTipos__ ? "/content/v3/styles/css/matchtracker/source/Synot-logo.png" : "/content/styles/css/matchtracker/source/pitch-logo-23.png",
            goalBannerCustomBgColor: __IsMTS__ && !__IsMTSTipos__ ? "#e31e39" : "#25247B",
            logo: [(__IsMTS__ && !__IsMTSTipos__ ? "/content/v3/styles/css/matchtracker/source/Synot-logo.png" : "/content/styles/css/matchtracker/source/report-logo-23.png")]
        };

        if (props.operator === LiveStreamOperatorType.MatchTrackerBR) {
            params.matchId = props.externalId;
        } else if (props.operator === LiveStreamOperatorType.MatchTrackerBRStage) {
            params.stageId = props.externalId;
        } else {
            throw new Error("Unexpected match type " + props.operator);
        }

        if (stateWidgetExists) {
            window['SIR']("updateWidget", elementIdentifier, params);
        } else {
            window['SIR']("addWidget", elementIdentifier, "match.lmtPlus", params);
            stateSetWidgetExists(true);
        }

        props.shownForMonitoring();
    };

    const onResize = () => {
        if (wrapperRef && wrapperRef.current) {
            let newValue = wrapperRef.current.clientWidth / (wrapperRef.current.clientWidth > 300 ? 1.22 : 1);
            if (newValue !== stateWrapperMinHeight) { //every page rerender, stateWrapperMinWidth is -1
                setStateWrapperMinWidth(newValue);
            }
        }
    }

    if (props.canFixHeightOnLoad) {
        window.addEventListener("resize", onResize);
        onResize();
    }

    return <div id={props.elementId} style={{ maxWidth: "640px", minHeight: (props.canFixHeightOnLoad && stateWrapperMinHeight > 0 ? stateWrapperMinHeight : undefined), margin: "auto" }} ref={wrapperRef} >
        <div style={{ paddingTop: '100%', position: "relative" }}>
            <div style={{ position: 'absolute', transform: 'translate(-50%, -50%)', top: '50%', left: '50%' }}><span className="fas fa-spinner fa-spin"></span> {translation().general_Loading}</div>
        </div>

    </div >
}